/**
 * "(555) 123-4567" for a US number, with or without a leading 1 / +1;
 * anything else comes back as given. Empty input gives ''.
 */
export function formatPhone(
  phone?: string | null,
  opts: { countryCode?: boolean } = {},
): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length !== 10) return phone;
  const local = `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  return opts.countryCode ? `+1 ${local}` : local;
}

/** `tel:` link, assuming +1 when the number has no country code. */
export function telHref(phone?: string | null): string | undefined {
  if (!phone) return undefined;
  const cleaned = phone.replace(/[^\d+]/g, '');
  return `tel:${cleaned.startsWith('+') ? cleaned : `+1${cleaned.replace(/^1/, '')}`}`;
}
